import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useEffect, useRef, useState } from 'react';
import { FaCircle } from 'react-icons/fa';
import { MdKeyboardArrowDown } from 'react-icons/md';

const BugContent = ({ item }) => {
  const {
    fields: { summary, status },
    key,
  } = item;
  const [taskStatus, setStoryStatus] = useState(status.name);
  const [showStatusOptions, setShowStatusOptions] = useState(false);
  const hanldeStatusChange = (status) => {
    setStoryStatus(status);
    setShowStatusOptions(false);
  };
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  const statusRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (statusRef.current && !statusRef.current.contains(event.target)) {
        setShowStatusOptions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <div
      className="flex w-full flex-col gap-3 border border-zinc-700 bg-zinc-900 px-2 text-gray-50 transition duration-100  hover:bg-zinc-800"
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={style}
    >
      <div
        className={`flex w-full items-center justify-between py-1.5 transition duration-100 hover:text-white`}
      >
        <div className="flex items-center gap-3">
          <span className="rounded-md bg-red-600 p-1">
            <FaCircle className="text-white" size={12} />
          </span>
          <span className="text-base font-semibold">{key}</span>
          <div ref={statusRef} className="mr-3">
            <button
              className={`relative flex items-center justify-center gap-1 rounded-3xl border border-black px-2 py-0.5 text-[12px] uppercase ${
                taskStatus === 'To Do' ? 'bg-[#5652CF]' : 'bg-green-500'
              }`}
              onClick={(e) => {
                e.stopPropagation();
                setShowStatusOptions((prev) => !prev);
              }}
            >
              <span className="mt-1">{taskStatus}</span>
              <MdKeyboardArrowDown />
            </button>
            {showStatusOptions && (
              <div
                className={`absolute ${
                  showStatusOptions ? 'flex' : 'hidden'
                } z-50 flex-col items-center justify-center gap-2 rounded-lg bg-[#1d1d1f] p-2 text-gray-50`}
              >
                {/* eslint-disable-next-line */}
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    hanldeStatusChange('In Progress');
                  }}
                  className="cursor-pointer text-nowrap p-1 text-sm font-semibold hover:text-white"
                >
                  In Progress
                </span>
                {/* eslint-disable-next-line */}
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    hanldeStatusChange('To Do');
                  }}
                  className="cursor-pointer text-nowrap p-1 text-sm font-semibold hover:text-white"
                >
                  To Do
                </span>
              </div>
            )}
          </div>
          <p className=" text-base font-semibold">{summary}</p>
        </div>
        <div className="flex items-center gap-4"></div>
      </div>
    </div>
  );
};

export default BugContent;
